/**
 * Define loding plugin
 *
 * @author minkyoung.park@emcast.com
 */

import Loading from './Loading.vue'

const loadingPlugin = {
    install(Vue, optiuons) {
        let loadingConstructor = Vue.extend(Loading)
        let loadingInstance = null
        loadingInstance = new loadingConstructor({
            el: document.createElement('div')
        })

        Vue.prototype.$showLoading = function (payload) {

            if (payload) {
                payload.appendChild(loadingInstance.$el)
            } else {
                document.body.appendChild(loadingInstance.$el)
            }

            loadingInstance.show(payload)
        }

        Vue.prototype.$hideLoading = function () {
            loadingInstance.hide()
        }
    }
}

export default loadingPlugin